import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import weakPasswordLine from '../../../assets/images/icon/password-strength-zwak.svg';
import strongPasswordLine from '../../../assets/images/icon/password-strength-sterk.svg';

const Wrapper = styled.div`
	position: absolute;
	top: 55px;
	left: 0;
	right: 0
`;

const Line = styled.div`
	height: 5px;
	background: url(${props => props.strength === 'strong' ? strongPasswordLine : weakPasswordLine}) 0 0 ${props => props.strength === 'weak' && 'no-repeat'};

`;
Line.propTypes = {
	strength: PropTypes.string.isRequired
};

const Status = styled.div`
	padding: 5px 10px 0 0;
	font-family: Montserrat;
	font-size: 12px;
	color: #9a9183;
	text-align: right;
`;

const PasswordStrength = ({ strength, strongPasswordMsg = '', weakPasswordMsg = '' }) => (
	<Wrapper>
		<Line strength={strength} />
		{strength === 'strong' && strongPasswordMsg
			? <Status>{strongPasswordMsg}</Status>
			: strength === 'weak' && weakPasswordMsg
				? <Status>{weakPasswordMsg}</Status>
				: null
		}
	</Wrapper>
);

PasswordStrength.propTypes = {
	strength: PropTypes.string.isRequired,
	strongPasswordMsg: PropTypes.string,
	weakPasswordMsg: PropTypes.string
};

export default PasswordStrength;
